import { css } from '@emotion/react'
import {
  Alert,
  Heading,
  Text,
  SpacingToken,
} from '@livechat/design-system-react-components'

export const alertWrapperCss = css`
  margin-bottom: 30px;

  div {
    margin-right: 0;
  }

  h5 {
    margin: 0 0 var(${SpacingToken.Spacing2});
  }

  button {
    margin-top: var(${SpacingToken.Spacing3});
  }
`

const ActivationProductAlert = () => (
  <Alert css={alertWrapperCss} kind="info">
    <Heading size="xs">This app requires activation</Heading>
    <Text>
      The app is now installed on your license. To finish the installation
      process, please activate this app.
    </Text>
  </Alert>
)

export default ActivationProductAlert
